import { render, staticRenderFns } from "./ModalContinueMessage.vue?vue&type=template&id=7bdfa6d0&scoped=true&"
import script from "./ModalContinueMessage.vue?vue&type=script&lang=js&"
export * from "./ModalContinueMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdfa6d0",
  null
  
)

export default component.exports